module.exports = __webpack_public_path__ + "img/marker_schedule.00a48ab1.png";